import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const useAdminContext = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdminContext must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [activeView, setActiveView] = useState('dashboard');

  const switchView = (view) => {
    setActiveView(view);
  };

  useEffect(() => {
    // 监听自定义事件来切换视图
    const handleSwitchView = (event) => {
      switchView(event.detail);
    };

    window.addEventListener('adminSwitchView', handleSwitchView);
    
    return () => {
      window.removeEventListener('adminSwitchView', handleSwitchView);
    };
  }, []);

  return (
    <AdminContext.Provider value={{ activeView, switchView }}>
      {children}
    </AdminContext.Provider>
  );
};

